import {
  DateRangeDto,
  ExcelExportRequestDto,
  ReportsClient,
} from "src/util/apiClient";

export const excelExport = async (
  range: DateRangeDto,
  userId?: number | null,
  projectId?: number | null,
) => {
  const client = new ReportsClient();
  const request = ExcelExportRequestDto.fromJS({
    range: range.toJSON(),
    userId: userId ?? undefined,
    projectId: projectId ?? undefined,
  });

  const response = await client.exportExcel(request);
  if (!response) return;

  const link = document.createElement("a");
  link.href = URL.createObjectURL(response.data);
  link.download = response.fileName ?? "worktime_export.xlsx";
  link.click();
  URL.revokeObjectURL(link.href);
};
